import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { cn } from '@/lib/utils';

interface CopyableTextProps {
  value: string;
  className?: string;
  mono?: boolean;
}

export const CopyableText = ({ value, className, mono }: CopyableTextProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success('Copied to clipboard');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Failed to copy');
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={cn(
        'inline-flex items-center gap-1 group cursor-pointer',
        'border-b border-dashed border-zinc-300 hover:border-zinc-500',
        'transition-colors',
        className,
      )}
      title="Click to copy"
    >
      <span className={cn(mono && 'font-mono text-[12px]')}>{value}</span>
      {copied ? (
        <Check className="h-3 w-3 text-emerald-700 flex-shrink-0" />
      ) : (
        <Copy className="h-3 w-3 text-zinc-400 flex-shrink-0" />
      )}
    </button>
  );
};
